import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/img/icon/info.svg';
import _imports_1 from '@/img/icon/circle-1.svg';
import _imports_2 from '@/img/icon/circle-2.svg';
import _imports_3 from '@/img/icon/circle-3.svg';
import _imports_4 from '@/img/icon/location-white.svg';
import _imports_5 from '@/img/icon/arrow-green.svg';
import _imports_6 from '@/img/icon/check-green.svg';
import _imports_7 from '@/img/icon/warning.svg';
import _imports_8 from '@/img/icon/plus-green.svg';
const _withScopeId = n => (_pushScopeId("data-v-4227de13"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "order"
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = {
  class: "order__inner"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "order-title"
}, "Оформление заказа", -1));
const _hoisted_5 = {
  class: "order-wrapper"
};
const _hoisted_6 = {
  class: "order-left"
};
const _hoisted_7 = {
  class: "order__person"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", {
  class: "order__person-title"
}, "Личные данные", -1));
const _hoisted_9 = {
  class: "order__person-inputs"
};
const _hoisted_10 = {
  class: "order__delivery"
};
const _hoisted_11 = {
  class: "order__delivery-head"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", {
  class: "order__delivery-title"
}, "Доставка", -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "order-dialog__text"
}, " Выберите место на карте, а мы проверим возможна ли доставка в эту зону ", -1));
const _hoisted_15 = ["element-loading-spinner"];
const _hoisted_16 = ["src"];
const _hoisted_17 = {
  class: "order-dialog__check-address"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "—", -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("ul", {
  class: "order-dialog__list"
}, [/*#__PURE__*/_createElementVNode("li", {
  class: "order-dialog__list-item"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "zone"
}), /*#__PURE__*/_createElementVNode("span", null, "—"), /*#__PURE__*/_createElementVNode("p", {
  class: "order-dialog__list-text"
}, "Бесплатная доставка")]), /*#__PURE__*/_createElementVNode("li", {
  class: "order-dialog__list-item"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "zone"
}), /*#__PURE__*/_createElementVNode("span", null, "—"), /*#__PURE__*/_createElementVNode("p", {
  class: "order-dialog__list-text"
}, "Платная доставка")]), /*#__PURE__*/_createElementVNode("li", {
  class: "order-dialog__list-item"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "zone"
}), /*#__PURE__*/_createElementVNode("span", null, "—"), /*#__PURE__*/_createElementVNode("p", {
  class: "order-dialog__list-text"
}, "Доставку не делаем")])], -1));
const _hoisted_20 = {
  class: "destination__map"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "order__delivery-text"
}, " Зона бесплатной доставки уточняется у оператора ", -1));
const _hoisted_23 = {
  class: "tabs-wrapper"
};
const _hoisted_24 = {
  class: "tabs__content"
};
const _hoisted_25 = {
  key: 0,
  class: "tab__content"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "delivery__text"
}, "Минимальная сумма заказа 400 грн", -1));
const _hoisted_27 = {
  key: 0,
  class: "delivery__old"
};
const _hoisted_28 = {
  class: "address__list"
};
const _hoisted_29 = {
  class: "address__info"
};
const _hoisted_30 = {
  class: "address__address"
};
const _hoisted_31 = {
  class: "address__other"
};
const _hoisted_32 = ["value"];
const _hoisted_33 = {
  class: "delivery__btns"
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "delivery__btn"
}, "Удалить адрес", -1));
const _hoisted_35 = {
  class: "delivery__other"
};
const _hoisted_36 = {
  for: "delivery__other-1",
  class: "delivery__other-label"
};
const _hoisted_37 = {
  class: "delivery__other-check"
};
const _hoisted_38 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
};
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-dasharray": "24",
  "stroke-dashoffset": "24",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "3",
  d: "M5 11L11 17L21 7"
}, [/*#__PURE__*/_createElementVNode("animate", {
  fill: "freeze",
  attributeName: "stroke-dashoffset",
  dur: "0.4s",
  values: "24;0"
})], -1));
const _hoisted_40 = [_hoisted_39];
const _hoisted_41 = {
  for: "delivery__other-2",
  class: "delivery__other-label"
};
const _hoisted_42 = {
  class: "delivery__other-check"
};
const _hoisted_43 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
};
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-dasharray": "24",
  "stroke-dashoffset": "24",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "3",
  d: "M5 11L11 17L21 7"
}, [/*#__PURE__*/_createElementVNode("animate", {
  fill: "freeze",
  attributeName: "stroke-dashoffset",
  dur: "0.4s",
  values: "24;0"
})], -1));
const _hoisted_45 = [_hoisted_44];
const _hoisted_46 = {
  key: 1,
  class: "delivery__new"
};
const _hoisted_47 = {
  class: "delivery__new-city"
};
const _hoisted_48 = {
  for: "city-1",
  class: "delivery__new-label"
};
const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Киев", -1));
const _hoisted_50 = {
  for: "city-2",
  class: "delivery__new-label"
};
const _hoisted_51 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Днепр", -1));
const _hoisted_52 = {
  for: "city-3",
  class: "delivery__new-label"
};
const _hoisted_53 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Харьков", -1));
const _hoisted_54 = {
  for: "city-4",
  class: "delivery__new-label"
};
const _hoisted_55 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Одесса", -1));
const _hoisted_56 = {
  class: "address"
};
const _hoisted_57 = {
  class: "delivery__new-inputs"
};
const _hoisted_58 = {
  class: "delivery__other"
};
const _hoisted_59 = {
  for: "delivery__other-1",
  class: "delivery__other-label"
};
const _hoisted_60 = {
  class: "delivery__other-check"
};
const _hoisted_61 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
};
const _hoisted_62 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-dasharray": "24",
  "stroke-dashoffset": "24",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "3",
  d: "M5 11L11 17L21 7"
}, [/*#__PURE__*/_createElementVNode("animate", {
  fill: "freeze",
  attributeName: "stroke-dashoffset",
  dur: "0.4s",
  values: "24;0"
})], -1));
const _hoisted_63 = [_hoisted_62];
const _hoisted_64 = {
  for: "delivery__other-2",
  class: "delivery__other-label"
};
const _hoisted_65 = {
  class: "delivery__other-check"
};
const _hoisted_66 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
};
const _hoisted_67 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-dasharray": "24",
  "stroke-dashoffset": "24",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "3",
  d: "M5 11L11 17L21 7"
}, [/*#__PURE__*/_createElementVNode("animate", {
  fill: "freeze",
  attributeName: "stroke-dashoffset",
  dur: "0.4s",
  values: "24;0"
})], -1));
const _hoisted_68 = [_hoisted_67];
const _hoisted_69 = {
  class: "delivery__new-back"
};
const _hoisted_70 = ["disabled"];
const _hoisted_71 = {
  key: 0,
  class: "delivery__new-back__box"
};
const _hoisted_72 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "custom-loading"
}, [/*#__PURE__*/_createElementVNode("svg", {
  class: "circular",
  viewBox: "-10, -10, 50, 50"
}, [/*#__PURE__*/_createElementVNode("path", {
  class: "path",
  d: "\n                                          M 30 15\n                                          L 28 17\n                                          M 25.61 25.61\n                                          A 15 15, 0, 0, 1, 15 30\n                                          A 15 15, 0, 1, 1, 27.99 7.5\n                                          L 15 15\n                                        ",
  style: {
    "stroke-width": "4px",
    "fill": "rgba(0, 0, 0, 0)"
  }
})])], -1));
const _hoisted_73 = {
  class: "delivery__new-back__loading"
};
const _hoisted_74 = {
  key: 1,
  class: "delivery__new-back__box"
};
const _hoisted_75 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
}, null, -1));
const _hoisted_76 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Назад", -1));
const _hoisted_77 = [_hoisted_75, _hoisted_76];
const _hoisted_78 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "delivery__new-back__text"
}, " Адрес доставки сохранится автоматически ", -1));
const _hoisted_79 = {
  key: 1,
  class: "tab__content"
};
const _hoisted_80 = {
  class: "delivery__new-city"
};
const _hoisted_81 = {
  for: "city-1",
  class: "delivery__new-label"
};
const _hoisted_82 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Киев", -1));
const _hoisted_83 = {
  for: "city-2",
  class: "delivery__new-label"
};
const _hoisted_84 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Днепр", -1));
const _hoisted_85 = {
  for: "city-3",
  class: "delivery__new-label"
};
const _hoisted_86 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Харьков", -1));
const _hoisted_87 = {
  for: "city-4",
  class: "delivery__new-label"
};
const _hoisted_88 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Одесса", -1));
const _hoisted_89 = {
  class: "address"
};
const _hoisted_90 = {
  class: "order__time"
};
const _hoisted_91 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "order__time-title"
}, "Время доставки", -1));
const _hoisted_92 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "order__time-text"
}, "Время доставки заказа уточните по телефону.", -1));
const _hoisted_93 = {
  class: "order__time-selects"
};
const _hoisted_94 = {
  class: "order__time-select"
};
const _hoisted_95 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "order__time-select-title"
}, "День", -1));
const _hoisted_96 = {
  class: "order__time-select-item"
};
const _hoisted_97 = {
  class: "order__time-select"
};
const _hoisted_98 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "order__time-select-title"
}, "Время", -1));
const _hoisted_99 = {
  class: "order__payment"
};
const _hoisted_100 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "order__payment-title"
}, "Способ оплаты", -1));
const _hoisted_101 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "order__payment-text"
}, " Алкогольные напитки оплачиваются только наличными ", -1));
const _hoisted_102 = {
  key: 0,
  action: ""
};
const _hoisted_103 = {
  class: "order__payment-list"
};
const _hoisted_104 = {
  class: "order__payment-label",
  for: "radio-1"
};
const _hoisted_105 = {
  class: "order__payment-label",
  for: "radio-2"
};
const _hoisted_106 = {
  class: "order__payment-label",
  for: "radio-3"
};
const _hoisted_107 = {
  class: "order__payment-label",
  for: "radio-4"
};
const _hoisted_108 = {
  key: 1,
  action: ""
};
const _hoisted_109 = {
  class: "order__payment-list"
};
const _hoisted_110 = {
  class: "order__payment-label",
  for: "radio-1"
};
const _hoisted_111 = {
  class: "order__payment-label",
  for: "radio-2"
};
const _hoisted_112 = {
  class: "order__payment-label",
  for: "radio-3"
};
const _hoisted_113 = {
  key: 2,
  class: "order__payment-change"
};
const _hoisted_114 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "грн", -1));
const _hoisted_115 = {
  class: "order__comment"
};
const _hoisted_116 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "order__comment-title"
}, "Комментарий", -1));
const _hoisted_117 = {
  class: "order__comment-inputs"
};
const _hoisted_118 = {
  class: "delivery__other"
};
const _hoisted_119 = {
  for: "order__comment-1",
  class: "delivery__other-label"
};
const _hoisted_120 = {
  class: "delivery__other-check"
};
const _hoisted_121 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
};
const _hoisted_122 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-dasharray": "24",
  "stroke-dashoffset": "24",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "3",
  d: "M5 11L11 17L21 7"
}, [/*#__PURE__*/_createElementVNode("animate", {
  fill: "freeze",
  attributeName: "stroke-dashoffset",
  dur: "0.4s",
  values: "24;0"
})], -1));
const _hoisted_123 = [_hoisted_122];
const _hoisted_124 = {
  for: "order__comment-2",
  class: "delivery__other-label"
};
const _hoisted_125 = {
  class: "delivery__other-check"
};
const _hoisted_126 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
};
const _hoisted_127 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-dasharray": "24",
  "stroke-dashoffset": "24",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "3",
  d: "M5 11L11 17L21 7"
}, [/*#__PURE__*/_createElementVNode("animate", {
  fill: "freeze",
  attributeName: "stroke-dashoffset",
  dur: "0.4s",
  values: "24;0"
})], -1));
const _hoisted_128 = [_hoisted_127];
const _hoisted_129 = {
  class: "order-right"
};
const _hoisted_130 = {
  class: "order__total"
};
const _hoisted_131 = {
  class: "order__total-promokod"
};
const _hoisted_132 = {
  key: 0,
  class: "order__total-novalid"
};
const _hoisted_133 = {
  key: 0,
  src: _imports_6,
  alt: ""
};
const _hoisted_134 = {
  key: 1,
  src: _imports_7,
  alt: ""
};
const _hoisted_135 = ["disabled"];
const _hoisted_136 = {
  key: 0,
  class: "order__total-btn-box"
};
const _hoisted_137 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "custom-loading"
}, [/*#__PURE__*/_createElementVNode("svg", {
  class: "circular",
  viewBox: "-10, -10, 50, 50"
}, [/*#__PURE__*/_createElementVNode("path", {
  class: "path",
  d: "\n                                          M 30 15\n                                          L 28 17\n                                          M 25.61 25.61\n                                          A 15 15, 0, 0, 1, 15 30\n                                          A 15 15, 0, 1, 1, 27.99 7.5\n                                          L 15 15\n                                        ",
  style: {
    "stroke-width": "4px",
    "fill": "rgba(0, 0, 0, 0)"
  }
})])], -1));
const _hoisted_138 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Подождите...", -1));
const _hoisted_139 = [_hoisted_137, _hoisted_138];
const _hoisted_140 = {
  key: 1
};
const _hoisted_141 = {
  key: 0,
  class: "order__total-list"
};
const _hoisted_142 = {
  class: "order__total-list-left"
};
const _hoisted_143 = {
  class: "order__total-imgwrapper"
};
const _hoisted_144 = ["src"];
const _hoisted_145 = {
  class: "order__total-info"
};
const _hoisted_146 = {
  class: "order__total-list-title"
};
const _hoisted_147 = {
  class: "order__total-list-weight"
};
const _hoisted_148 = {
  class: "order__total-list-right"
};
const _hoisted_149 = {
  class: "order__total-count"
};
const _hoisted_150 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "order__total-free"
}, "Бесплатно", -1));
const _hoisted_151 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "order__total-list-btn"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  alt: ""
})], -1));
const _hoisted_152 = {
  class: "order__total-box"
};
const _hoisted_153 = {
  class: "order__total-left"
};
const _hoisted_154 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "order__total-text"
}, "Итого:", -1));
const _hoisted_155 = {
  class: "order__total-price"
};
const _hoisted_156 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "грн", -1));
const _hoisted_157 = ["disabled"];
const _hoisted_158 = {
  key: 0,
  class: "order__total-btn-box"
};
const _hoisted_159 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "custom-loading"
}, [/*#__PURE__*/_createElementVNode("svg", {
  class: "circular",
  viewBox: "-10, -10, 50, 50"
}, [/*#__PURE__*/_createElementVNode("path", {
  class: "path",
  d: "\n                                          M 30 15\n                                          L 28 17\n                                          M 25.61 25.61\n                                          A 15 15, 0, 0, 1, 15 30\n                                          A 15 15, 0, 1, 1, 27.99 7.5\n                                          L 15 15\n                                        ",
  style: {
    "stroke-width": "4px",
    "fill": "rgba(0, 0, 0, 0)"
  }
})])], -1));
const _hoisted_160 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Отправка...", -1));
const _hoisted_161 = [_hoisted_159, _hoisted_160];
const _hoisted_162 = {
  key: 1
};
const _hoisted_163 = {
  key: 1,
  class: "order__total-warning"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Category = _resolveComponent("Category");
  const _component_Crumbs = _resolveComponent("Crumbs");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_Map = _resolveComponent("Map");
  const _component_app_button = _resolveComponent("app-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_el_popconfirm = _resolveComponent("el-popconfirm");
  const _component_el_autocomplete = _resolveComponent("el-autocomplete");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_CartList = _resolveComponent("CartList");
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  const _component_EmptyBlock = _resolveComponent("EmptyBlock");
  const _component_SliderOrder = _resolveComponent("SliderOrder");
  const _directive_mask = _resolveDirective("mask");
  const _directive_loading = _resolveDirective("loading");
  const _directive_auto_animate = _resolveDirective("auto-animate");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_Category, {
    class: "category-pages"
  }), _createVNode(_component_Crumbs, {
    paths: $data.paths,
    class: "crumbs"
  }, null, 8, ["paths"]), _hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createVNode(_component_el_form, {
    ref: "ruleFormRef3",
    model: $setup.form
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_form_item, {
      label: "Имя",
      prop: "name",
      rules: $setup.rules.name
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $setup.form.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.form.name = $event),
        placeholder: "Ввод"
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 8, ["rules"]), _createVNode(_component_el_form_item, {
      label: "Телефон",
      prop: "tel",
      rules: $setup.rules.tel
    }, {
      default: _withCtx(() => [_withDirectives(_createVNode(_component_el_input, {
        modelValue: $setup.form.tel,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.form.tel = $event),
        placeholder: "Ввод"
      }, null, 8, ["modelValue"]), [[_directive_mask, ['+7 (###) ###-##-##']]])]),
      _: 1
    }, 8, ["rules"])])]),
    _: 1
  }, 8, ["model"])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createVNode(_component_el_tooltip, {
    content: "Проверьте входит ли ваш адрес в зону доставки"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_button, {
      plain: "",
      onClick: _cache[2] || (_cache[2] = $event => {
        $data.dialogVisible = true;
        this.$store.commit('map/setDeliveryCheck', false);
      })
    }, {
      default: _withCtx(() => [_createTextVNode(" Зона доставки "), _hoisted_13]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_dialog, {
    modelValue: $data.dialogVisible,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.dialogVisible = $event),
    title: "Зона доставки",
    "align-center": ""
  }, {
    default: _withCtx(() => [_hoisted_14, _ctx.deliveryCheck ? _withDirectives((_openBlock(), _createElementBlock("div", {
      key: 0,
      "element-loading-spinner": $data.svg,
      "element-loading-svg-view-box": "-10, -10, 50, 50",
      class: "order-dialog__check"
    }, [_createElementVNode("img", {
      class: "order-dialog__check-img",
      src: _ctx.deliveryPossible ? require('@/img/icon/check-green.svg') : require('@/img/icon/none.svg'),
      alt: ""
    }, null, 8, _hoisted_16), _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.addressDialog), 1), _hoisted_18, _createElementVNode("p", {
      class: _normalizeClass(_ctx.deliveryPossible ? 'order-dialog__check-green' : 'order-dialog__check-red')
    }, _toDisplayString(_ctx.deliveryPossible ? "Доставка возможна" : "Доставка невозможна"), 3)], 8, _hoisted_15)), [[_directive_loading, _ctx.loadingDeliveryCheck]]) : _createCommentVNode("", true), _hoisted_19, _createElementVNode("div", _hoisted_20, [_createVNode(_component_Map, {
      geocoderCoord: $options.geocoderCoord,
      ref: "Map"
    }, null, 8, ["geocoderCoord"])]), _createVNode(_component_app_button, {
      class: "order-dialog__btn",
      onClick: _cache[3] || (_cache[3] = $event => _ctx.checkAddress({
        lat: $data.lat,
        long: $data.long
      })),
      disabled: _ctx.loadingDeliveryCheck
    }, {
      default: _withCtx(() => [_hoisted_21, _createTextVNode(" Проверить адрес ")]),
      _: 1
    }, 8, ["disabled"])]),
    _: 1
  }, 8, ["modelValue"])]), _hoisted_22, _createElementVNode("div", _hoisted_23, [_createElementVNode("div", {
    class: _normalizeClass(["tabs order__tabs", $data.tab === 'tab_1' ? 'tabs-active-1' : 'tabs-active-2'])
  }, [_createElementVNode("div", {
    class: _normalizeClass(["tab", {
      'tab--is-active': $data.tab === 'tab_1'
    }]),
    onClick: _cache[5] || (_cache[5] = $event => $data.tab = 'tab_1')
  }, " Доставка ", 2), _createElementVNode("div", {
    class: _normalizeClass(["tab", {
      'tab--is-active': $data.tab === 'tab_2'
    }]),
    onClick: _cache[6] || (_cache[6] = $event => ($data.tab = 'tab_2', $options.fetchRestaurant()))
  }, " Самовывоз ", 2)], 2), _createElementVNode("div", _hoisted_24, [$data.tab === 'tab_1' ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_hoisted_26, !$data.addAddress && $setup.address.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_withDirectives((_openBlock(), _createElementBlock("ul", _hoisted_28, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.address, (item, index) => {
    return _openBlock(), _createElementBlock("label", {
      class: "address__list-item",
      key: index
    }, [_createElementVNode("div", _hoisted_29, [_createElementVNode("p", _hoisted_30, _toDisplayString(`${item.city}, ${item.address}`), 1), _createElementVNode("p", _hoisted_31, " Подьезд " + _toDisplayString(item.input ? item.input : "(-)") + ", этаж " + _toDisplayString(item.floor ? item.floor : "(-)") + ", квартира " + _toDisplayString(item.apartment ? item.apartment : "(-)"), 1)]), _withDirectives(_createElementVNode("input", {
      type: "radio",
      name: "address",
      "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.addressRadio = $event),
      value: item.id
    }, null, 8, _hoisted_32), [[_vModelRadio, $data.addressRadio]])]);
  }), 128))])), [[_directive_auto_animate]]), _createElementVNode("div", _hoisted_33, [_createElementVNode("button", {
    class: "delivery__btn",
    onClick: _cache[8] || (_cache[8] = $event => $data.addAddress = true)
  }, " Добавить новый адрес "), _createVNode(_component_el_popconfirm, {
    width: "220",
    title: "Вы уверены что хотите удалить адрес?",
    onConfirm: $options.removeAddress,
    "confirm-button-text": "да",
    "cancel-button-text": "нет",
    "icon-color": "#626AEF",
    icon: $data.EpInfoFilled
  }, {
    reference: _withCtx(() => [_hoisted_34]),
    _: 1
  }, 8, ["onConfirm", "icon"])]), _createElementVNode("div", _hoisted_35, [_createElementVNode("label", _hoisted_36, [_withDirectives(_createElementVNode("input", {
    class: "delivery__other-input",
    type: "checkbox",
    id: "delivery__other-1",
    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.doorOptions1 = $event),
    value: "Не звонить в дверь"
  }, null, 512), [[_vModelCheckbox, $data.doorOptions1]]), _createElementVNode("div", _hoisted_37, [$data.doorOptions1.find(item => item === 'Не звонить в дверь') ? (_openBlock(), _createElementBlock("svg", _hoisted_38, _hoisted_40)) : _createCommentVNode("", true)]), _createTextVNode(" Не звонить в дверь ")]), _createElementVNode("label", _hoisted_41, [_withDirectives(_createElementVNode("input", {
    class: "delivery__other-input",
    type: "checkbox",
    id: "delivery__other-2",
    "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.doorOptions1 = $event),
    value: "Оставить под дверью"
  }, null, 512), [[_vModelCheckbox, $data.doorOptions1]]), _createElementVNode("div", _hoisted_42, [$data.doorOptions1.find(item => item === 'Оставить под дверью') ? (_openBlock(), _createElementBlock("svg", _hoisted_43, _hoisted_45)) : _createCommentVNode("", true)]), _createTextVNode(" Оставить под дверью ")])])])) : _createCommentVNode("", true), $data.addAddress || $setup.address.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_46, [_createVNode(_component_el_form, {
    ref: "ruleFormRef1",
    model: $setup.form
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_47, [_createElementVNode("label", _hoisted_48, [_withDirectives(_createElementVNode("input", {
      type: "radio",
      name: "city",
      id: "city-1",
      "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.cityRadio1 = $event),
      value: "Киев"
    }, null, 512), [[_vModelRadio, $data.cityRadio1]]), _hoisted_49]), _createElementVNode("label", _hoisted_50, [_withDirectives(_createElementVNode("input", {
      type: "radio",
      name: "city",
      id: "city-2",
      "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.cityRadio1 = $event),
      value: "Днепр"
    }, null, 512), [[_vModelRadio, $data.cityRadio1]]), _hoisted_51]), _createElementVNode("label", _hoisted_52, [_withDirectives(_createElementVNode("input", {
      type: "radio",
      name: "city",
      id: "city-3",
      "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $data.cityRadio1 = $event),
      value: "Харьков"
    }, null, 512), [[_vModelRadio, $data.cityRadio1]]), _hoisted_53]), _createElementVNode("label", _hoisted_54, [_withDirectives(_createElementVNode("input", {
      type: "radio",
      name: "city",
      id: "city-4",
      "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $data.cityRadio1 = $event),
      value: "Одесса"
    }, null, 512), [[_vModelRadio, $data.cityRadio1]]), _hoisted_55])]), _createVNode(_component_el_form_item, {
      label: "Улица, дом",
      prop: "address",
      rules: $setup.rules.address
    }, {
      default: _withCtx(() => [_createVNode(_component_el_autocomplete, {
        modelValue: $setup.form.address,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => $setup.form.address = $event),
        "fetch-suggestions": $options.fetchAddressSelect,
        "trigger-on-focus": true,
        "select-when-unmatched": false,
        placeholder: "Введите адрес",
        onSelect: $options.handleSelectAddress,
        onInput: _cache[16] || (_cache[16] = $event => this.checkFromSelect = false),
        debounce: 1000,
        clearable: "",
        "fit-input-width": "",
        "popper-class": "my-autocomplete",
        class: "destination__form-search"
      }, {
        default: _withCtx(({
          item
        }) => [_createElementVNode("div", _hoisted_56, _toDisplayString(item.address), 1)]),
        _: 1
      }, 8, ["modelValue", "fetch-suggestions", "onSelect"])]),
      _: 1
    }, 8, ["rules"]), _createElementVNode("div", _hoisted_57, [_createVNode(_component_el_form_item, {
      label: "Дом"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $setup.form.house,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => $setup.form.house = $event),
        placeholder: "Ввод"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "Подъезд"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $setup.form.input,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => $setup.form.input = $event),
        placeholder: "Ввод"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "Этаж"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $setup.form.floor,
        "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => $setup.form.floor = $event),
        placeholder: "Ввод"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "Квартира"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $setup.form.apartment,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => $setup.form.apartment = $event),
        placeholder: "Ввод"
      }, null, 8, ["modelValue"])]),
      _: 1
    })]), _createElementVNode("div", _hoisted_58, [_createElementVNode("label", _hoisted_59, [_withDirectives(_createElementVNode("input", {
      class: "delivery__other-input",
      type: "checkbox",
      id: "delivery__other-1",
      "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => $data.doorOptions2 = $event),
      value: "Не звонить в дверь"
    }, null, 512), [[_vModelCheckbox, $data.doorOptions2]]), _createElementVNode("div", _hoisted_60, [$data.doorOptions2.find(item => item === 'Не звонить в дверь') ? (_openBlock(), _createElementBlock("svg", _hoisted_61, _hoisted_63)) : _createCommentVNode("", true)]), _createTextVNode(" Не звонить в дверь ")]), _createElementVNode("label", _hoisted_64, [_withDirectives(_createElementVNode("input", {
      class: "delivery__other-input",
      type: "checkbox",
      id: "delivery__other-2",
      "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => $data.doorOptions2 = $event),
      value: "Оставить под дверью"
    }, null, 512), [[_vModelCheckbox, $data.doorOptions2]]), _createElementVNode("div", _hoisted_65, [$data.doorOptions2.find(item => item === 'Оставить под дверью') ? (_openBlock(), _createElementBlock("svg", _hoisted_66, _hoisted_68)) : _createCommentVNode("", true)]), _createTextVNode(" Оставить под дверью ")])]), _createElementVNode("div", _hoisted_69, [_createVNode(_component_el_form_item, null, {
      default: _withCtx(() => [_createElementVNode("button", {
        class: "delivery__new-back__btn",
        onClick: _cache[23] || (_cache[23] = _withModifiers($event => $options.sumbitForm($setup.ruleFormRef1), ["prevent"])),
        disabled: $data.loadingPostAddress || _ctx.loadingDeliveryCheck || _ctx.loadingAddress
      }, [$data.loadingPostAddress || _ctx.loadingDeliveryCheck || _ctx.loadingAddress ? (_openBlock(), _createElementBlock("div", _hoisted_71, [_hoisted_72, _createElementVNode("span", _hoisted_73, _toDisplayString(_ctx.loadingDeliveryCheck || _ctx.loadingAddress ? "Проверка адреса" : $data.loadingPostAddress ? "Идет отправка" : ""), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_74, _hoisted_77))], 8, _hoisted_70)]),
      _: 1
    }), _createVNode(_component_el_tooltip, {
      content: "Не забудьте нажать кнопку 'Назад' иначе адрес не сохранится"
    }, {
      default: _withCtx(() => [_hoisted_78]),
      _: 1
    })])]),
    _: 1
  }, 8, ["model"])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $data.tab === 'tab_2' ? (_openBlock(), _createElementBlock("div", _hoisted_79, [_createVNode(_component_el_form, {
    ref: "ruleFormRef2",
    model: $setup.form
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_80, [_createElementVNode("label", _hoisted_81, [_withDirectives(_createElementVNode("input", {
      type: "radio",
      name: "city",
      id: "city-1",
      onChange: _cache[24] || (_cache[24] = $event => ($options.fetchRestaurant(), $setup.form.restaurant = '')),
      "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => $data.cityRadio2 = $event),
      value: "Киев"
    }, null, 544), [[_vModelRadio, $data.cityRadio2]]), _hoisted_82]), _createElementVNode("label", _hoisted_83, [_withDirectives(_createElementVNode("input", {
      type: "radio",
      name: "city",
      id: "city-2",
      onChange: _cache[26] || (_cache[26] = $event => ($options.fetchRestaurant(), $setup.form.restaurant = '')),
      "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => $data.cityRadio2 = $event),
      value: "Днепр"
    }, null, 544), [[_vModelRadio, $data.cityRadio2]]), _hoisted_84]), _createElementVNode("label", _hoisted_85, [_withDirectives(_createElementVNode("input", {
      type: "radio",
      name: "city",
      id: "city-3",
      onChange: _cache[28] || (_cache[28] = $event => ($options.fetchRestaurant(), $setup.form.restaurant = '')),
      "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => $data.cityRadio2 = $event),
      value: "Харьков"
    }, null, 544), [[_vModelRadio, $data.cityRadio2]]), _hoisted_86]), _createElementVNode("label", _hoisted_87, [_withDirectives(_createElementVNode("input", {
      type: "radio",
      name: "city",
      id: "city-4",
      onChange: _cache[30] || (_cache[30] = $event => ($options.fetchRestaurant(), $setup.form.restaurant = '')),
      "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => $data.cityRadio2 = $event),
      value: "Одесса"
    }, null, 544), [[_vModelRadio, $data.cityRadio2]]), _hoisted_88])]), _createVNode(_component_el_form_item, {
      label: "Ресторан с которого будете забирать",
      prop: "restaurant",
      rules: $setup.rules.restaurant
    }, {
      default: _withCtx(() => [_createVNode(_component_el_autocomplete, {
        modelValue: $setup.form.restaurant,
        "onUpdate:modelValue": _cache[32] || (_cache[32] = $event => $setup.form.restaurant = $event),
        "fetch-suggestions": $options.filterArray,
        placeholder: "Введите адрес",
        onSelect: $options.handleSelect,
        onInput: _cache[33] || (_cache[33] = $event => this.fromSelectRestaurant = false),
        debounce: 500,
        clearable: "",
        "fit-input-width": "",
        "popper-class": "my-autocomplete",
        class: "destination__form-search"
      }, {
        default: _withCtx(({
          item
        }) => [_createElementVNode("div", _hoisted_89, _toDisplayString(item.address), 1)]),
        _: 1
      }, 8, ["modelValue", "fetch-suggestions", "onSelect"])]),
      _: 1
    }, 8, ["rules"])]),
    _: 1
  }, 8, ["model"])])) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_90, [_hoisted_91, _hoisted_92, _createElementVNode("div", _hoisted_93, [_createElementVNode("div", _hoisted_94, [_hoisted_95, _createVNode(_component_el_select, {
    modelValue: $data.selectDay,
    "onUpdate:modelValue": _cache[34] || (_cache[34] = $event => $data.selectDay = $event),
    "popper-class": "order-select",
    onChange: $options.generateTimeOptions
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.optionsDay, item => {
      return _openBlock(), _createBlock(_component_el_option, {
        key: item.value,
        label: item.label,
        value: item.value
      }, {
        default: _withCtx(() => [_createElementVNode("span", _hoisted_96, _toDisplayString(item.label), 1)]),
        _: 2
      }, 1032, ["label", "value"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "onChange"])]), _createElementVNode("div", _hoisted_97, [_hoisted_98, _createVNode(_component_el_select, {
    modelValue: $data.selectTime,
    "onUpdate:modelValue": _cache[35] || (_cache[35] = $event => $data.selectTime = $event),
    "popper-class": "order-select"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.optionsTime, item => {
      return _openBlock(), _createBlock(_component_el_option, {
        key: item.value,
        label: item.label,
        value: item.value
      }, null, 8, ["label", "value"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue"])])])]), _createElementVNode("div", _hoisted_99, [_hoisted_100, _hoisted_101, $data.tab === 'tab_1' ? (_openBlock(), _createElementBlock("form", _hoisted_102, [_createElementVNode("div", _hoisted_103, [_createElementVNode("label", _hoisted_104, [_withDirectives(_createElementVNode("input", {
    class: "order__payment-radio",
    type: "radio",
    name: "payment",
    id: "radio-1",
    "onUpdate:modelValue": _cache[36] || (_cache[36] = $event => $data.paymentDelivery = $event),
    checked: "",
    value: "Наличными курьеру"
  }, null, 512), [[_vModelRadio, $data.paymentDelivery]]), _createTextVNode(" Наличными курьеру ")]), _createElementVNode("label", _hoisted_105, [_withDirectives(_createElementVNode("input", {
    class: "order__payment-radio",
    type: "radio",
    name: "payment",
    id: "radio-2",
    "onUpdate:modelValue": _cache[37] || (_cache[37] = $event => $data.paymentDelivery = $event),
    value: "Оплата терминалом курьеру"
  }, null, 512), [[_vModelRadio, $data.paymentDelivery]]), _createTextVNode(" Оплата терминалом курьеру ")]), _createElementVNode("label", _hoisted_106, [_withDirectives(_createElementVNode("input", {
    class: "order__payment-radio",
    type: "radio",
    name: "payment",
    id: "radio-3",
    "onUpdate:modelValue": _cache[38] || (_cache[38] = $event => $data.paymentDelivery = $event),
    value: "Оплата картой online"
  }, null, 512), [[_vModelRadio, $data.paymentDelivery]]), _createTextVNode(" Оплата картой online ")]), _createElementVNode("label", _hoisted_107, [_withDirectives(_createElementVNode("input", {
    class: "order__payment-radio",
    type: "radio",
    name: "payment",
    id: "radio-4",
    "onUpdate:modelValue": _cache[39] || (_cache[39] = $event => $data.paymentDelivery = $event),
    value: "Оплата через BitPay"
  }, null, 512), [[_vModelRadio, $data.paymentDelivery]]), _createTextVNode(" Оплата через BitPay ")])])])) : _createCommentVNode("", true), $data.tab === 'tab_2' ? (_openBlock(), _createElementBlock("form", _hoisted_108, [_createElementVNode("div", _hoisted_109, [_createElementVNode("label", _hoisted_110, [_withDirectives(_createElementVNode("input", {
    class: "order__payment-radio",
    type: "radio",
    name: "payment",
    id: "radio-1",
    "onUpdate:modelValue": _cache[40] || (_cache[40] = $event => $data.paymentPickup = $event),
    checked: "",
    value: "Наличными в точке выдачи"
  }, null, 512), [[_vModelRadio, $data.paymentPickup]]), _createTextVNode(" Наличными в точке выдачи ")]), _createElementVNode("label", _hoisted_111, [_withDirectives(_createElementVNode("input", {
    class: "order__payment-radio",
    type: "radio",
    name: "payment",
    id: "radio-2",
    "onUpdate:modelValue": _cache[41] || (_cache[41] = $event => $data.paymentPickup = $event),
    value: "Оплата картой online"
  }, null, 512), [[_vModelRadio, $data.paymentPickup]]), _createTextVNode(" Оплата картой online ")]), _createElementVNode("label", _hoisted_112, [_withDirectives(_createElementVNode("input", {
    class: "order__payment-radio",
    type: "radio",
    name: "payment",
    id: "radio-3",
    "onUpdate:modelValue": _cache[42] || (_cache[42] = $event => $data.paymentPickup = $event),
    value: "Оплата через BitPay"
  }, null, 512), [[_vModelRadio, $data.paymentPickup]]), _createTextVNode(" Оплата через BitPay ")])])])) : _createCommentVNode("", true), $data.paymentDelivery === 'Наличными курьеру' && $data.tab === 'tab_1' || $data.paymentPickup === 'Наличными в точке выдачи' && $data.tab === 'tab_2' ? (_openBlock(), _createElementBlock("div", _hoisted_113, [_createVNode(_component_el_form, {
    ref: "ruleFormRef5",
    model: $setup.form
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      label: "Подготовить сдачу с",
      prop: "change",
      rules: $setup.rules.number,
      class: "order__payment-change-input"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $setup.form.change,
        "onUpdate:modelValue": _cache[43] || (_cache[43] = $event => $setup.form.change = $event),
        modelModifiers: {
          number: true
        },
        placeholder: "500"
      }, {
        suffix: _withCtx(() => [_hoisted_114]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }, 8, ["rules"])]),
    _: 1
  }, 8, ["model"])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_115, [_hoisted_116, _createVNode(_component_el_form, {
    ref: "ruleFormRef4",
    model: $setup.form
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_117, [_createVNode(_component_el_form_item, {
      label: "Обычные палочки",
      prop: "comment1",
      rules: $setup.rules.number
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $setup.form.comment1,
        "onUpdate:modelValue": _cache[44] || (_cache[44] = $event => $setup.form.comment1 = $event),
        modelModifiers: {
          number: true
        },
        placeholder: "4"
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 8, ["rules"]), _createVNode(_component_el_form_item, {
      label: "Учебные палочки",
      prop: "comment2",
      rules: $setup.rules.number
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $setup.form.comment2,
        "onUpdate:modelValue": _cache[45] || (_cache[45] = $event => $setup.form.comment2 = $event),
        modelModifiers: {
          number: true
        },
        placeholder: "1"
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 8, ["rules"])]), _createVNode(_component_el_form_item, {
      label: "Примечание к заказу"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        class: "order__comment-textarea",
        modelValue: $setup.form.note,
        "onUpdate:modelValue": _cache[46] || (_cache[46] = $event => $setup.form.note = $event),
        type: "textarea",
        rows: 2
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createElementVNode("div", _hoisted_118, [_createElementVNode("label", _hoisted_119, [_withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[47] || (_cache[47] = $event => $data.animals = $event),
      class: "delivery__other-input",
      type: "checkbox",
      id: "order__comment-1",
      value: "cat"
    }, null, 512), [[_vModelCheckbox, $data.animals]]), _createElementVNode("div", _hoisted_120, [$data.animals.find(item => item === 'cat') ? (_openBlock(), _createElementBlock("svg", _hoisted_121, _hoisted_123)) : _createCommentVNode("", true)]), _createTextVNode(" У меня есть кошка ")]), _createElementVNode("label", _hoisted_124, [_withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[48] || (_cache[48] = $event => $data.animals = $event),
      class: "delivery__other-input",
      type: "checkbox",
      id: "order__comment-2",
      value: "dog"
    }, null, 512), [[_vModelCheckbox, $data.animals]]), _createElementVNode("div", _hoisted_125, [$data.animals.find(item => item === 'dog') ? (_openBlock(), _createElementBlock("svg", _hoisted_126, _hoisted_128)) : _createCommentVNode("", true)]), _createTextVNode(" У меня есть собака ")])])]),
    _: 1
  }, 8, ["model"])])]), _createElementVNode("div", _hoisted_129, [_createVNode(_component_el_scrollbar, {
    "max-height": "700px"
  }, {
    default: _withCtx(() => [_createVNode(_component_CartList)]),
    _: 1
  }), $setup.cart.length === 0 ? (_openBlock(), _createBlock(_component_EmptyBlock, {
    key: 0,
    imgUrl: require('@/img/icon/cart-empty.svg'),
    title: "Вы еще не добавили товары в корзину",
    text: "Добавьте товары в корзину, чтобы сделать заказ"
  }, null, 8, ["imgUrl"])) : _createCommentVNode("", true), _withDirectives(_createVNode(_component_SliderOrder, {
    class: "order-added",
    slides: $setup.products,
    onOrderAddCart: _cache[49] || (_cache[49] = item => $setup.onClickAddPlus(item))
  }, null, 8, ["slides"]), [[_directive_loading, $data.sliderLoading]]), _createElementVNode("div", _hoisted_130, [_createVNode(_component_el_form, {
    ref: "ruleFormRef6"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_131, [_createVNode(_component_el_form_item, {
      class: "order__total-input"
    }, {
      default: _withCtx(() => [$setup.codeValid === false ? (_openBlock(), _createElementBlock("p", _hoisted_132, " Промокод введен не верно! ")) : _createCommentVNode("", true), _createVNode(_component_el_input, {
        placeholder: "Введите промокод",
        modelValue: $setup.form.code,
        "onUpdate:modelValue": _cache[50] || (_cache[50] = $event => $setup.form.code = $event)
      }, {
        suffix: _withCtx(() => [$setup.codeValid === true ? (_openBlock(), _createElementBlock("img", _hoisted_133)) : _createCommentVNode("", true), $setup.codeValid === false ? (_openBlock(), _createElementBlock("img", _hoisted_134)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, null, {
      default: _withCtx(() => [_createElementVNode("button", {
        class: "order__total-promokod-btn",
        onClick: _cache[51] || (_cache[51] = _withModifiers($event => $setup.codeValid === true ? $setup.cancelCode() : $setup.checkCode(), ["prevent"])),
        disabled: $setup.codeLoading || $setup.freeLoading
      }, [$setup.codeLoading ? (_openBlock(), _createElementBlock("div", _hoisted_136, _hoisted_139)) : _createCommentVNode("", true), !$setup.codeLoading ? (_openBlock(), _createElementBlock("span", _hoisted_140, _toDisplayString($setup.codeValid === true ? "Отменить" : "Применить"), 1)) : _createCommentVNode("", true)], 8, _hoisted_135)]),
      _: 1
    })])]),
    _: 1
  }, 512), $setup.freeProduct.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_141, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.freeProduct, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "order__total-item",
      key: item.id
    }, [_createElementVNode("div", _hoisted_142, [_createElementVNode("div", _hoisted_143, [_createElementVNode("img", {
      class: "order__total-img",
      src: require(`@/img/products/${item.imgUrl}`),
      alt: ""
    }, null, 8, _hoisted_144)]), _createElementVNode("div", _hoisted_145, [_createElementVNode("p", _hoisted_146, _toDisplayString(item.title), 1), _createElementVNode("p", _hoisted_147, "Вес: " + _toDisplayString(item.weight) + " г", 1)])]), _createElementVNode("div", _hoisted_148, [_createElementVNode("p", _hoisted_149, _toDisplayString(item.count) + " шт", 1), _hoisted_150]), _hoisted_151]);
  }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_152, [_createElementVNode("div", _hoisted_153, [_hoisted_154, _createElementVNode("p", _hoisted_155, [_createTextVNode(_toDisplayString($setup.totalPrice), 1), _hoisted_156])]), _createElementVNode("button", {
    onClick: _cache[52] || (_cache[52] = (...args) => $options.postOrder && $options.postOrder(...args)),
    class: "order__total-btn",
    disabled: $setup.totalPrice < 400 || $data.isCreatingOrder
  }, [$data.isCreatingOrder ? (_openBlock(), _createElementBlock("div", _hoisted_158, _hoisted_161)) : (_openBlock(), _createElementBlock("span", _hoisted_162, "Оформить заказ"))], 8, _hoisted_157)]), $setup.totalPrice < 400 ? (_openBlock(), _createElementBlock("p", _hoisted_163, " Минимальная сумма заказа 400 грн ")) : _createCommentVNode("", true)])])])])])]);
}